import { render, staticRenderFns } from "./PreviewForm16.vue?vue&type=template&id=16e24eed&scoped=true"
import script from "./PreviewForm16.vue?vue&type=script&lang=ts"
export * from "./PreviewForm16.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e24eed",
  null
  
)

export default component.exports